module.exports = __webpack_public_path__ + "static/img/Permiso(15).e378d9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/Permiso(15).jpg
// module id = eO7M
// module chunks = 0